import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getJoinNetworkWithLinkKey } from '../../utils/keys';
export const useJoinNetworkWithLink = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const joinNetworkKey = getJoinNetworkWithLinkKey();
    return useMutation((input) => client.auth.joinNetworkWithInvitationLink(input, fields), { mutationKey: joinNetworkKey, ...useMutationOptions });
};
//# sourceMappingURL=useJoinNetworkWithLink.js.map